var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"posts"},[_c('post-back',{attrs:{"title":_vm.tr.latest_publications}}),_c('div',{staticClass:"containers posts-container"},[_c('posts-grid',{attrs:{"posts":_vm.posts,"total":_vm.total}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }